import type { Audience } from "./online-status";

/**
 * A product declares the audiences it serves (`availableTo`); a viewer declares
 * the audiences they belong to. Whether a viewer may see it is the overlap.
 *
 * To let a new kind of shopper see more, add a branch to `audiencesFor` — every
 * caller of `isAvailableTo` inherits it.
 */
export interface Viewer {
	isConsultant: boolean;
}

const SHOPPER_AUDIENCES: readonly Audience[] = ["consumer", "pws", "guest"];

const CONSULTANT_AUDIENCES: readonly Audience[] = [
	...SHOPPER_AUDIENCES,
	"consultant"
];

export const SHOPPER: Viewer = { isConsultant: false };

export function audiencesFor(viewer: Viewer): readonly Audience[] {
	return viewer.isConsultant ? CONSULTANT_AUDIENCES : SHOPPER_AUDIENCES;
}

export function isAvailableTo(
	availableTo: Audience[] | undefined,
	viewer: Viewer
): boolean {
	const mine = audiencesFor(viewer);
	return (availableTo ?? []).some((audience) => mine.includes(audience));
}
